module.exports = __webpack_public_path__ + "static/img/4.a4cb15b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/eventBanner/4.jpg
// module id = 4ypd
// module chunks = 9